export default __webpack_public_path__ + "static/media/bg_198380561.dcad2c6f.webp";